module.exports = __webpack_public_path__ + "static/media/white-thumb-down.31a9f15f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/white-thumb-down.svg
// module id = 3233
// module chunks = 0